import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { LanguageProvider } from './context/LanguageContext';
import Home from './pages/Home';
import Catalogo from './pages/Catalogo';
import Empezar from './pages/Empezar';

function App() {
  return (
    <LanguageProvider>
      <Router>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/catalogo" element={<Catalogo />} />
          <Route path="/empezar" element={<Empezar />} />
        </Routes>
      </Router>
    </LanguageProvider>
  );
}

export default App;

